import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Heading } from '@grandvisionhq/elements';

const StoreSocialMedia = (_param)=>{
    var { className , labels , items  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "items"
    ]);
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-social-media-stores-v2', className)
    }), /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        component: "h3"
    }, labels.title), /*#__PURE__*/ React.createElement("ul", {
        className: "store-social-media-stores-v2__list"
    }, items.map(({ name , url , iconUrl  })=>/*#__PURE__*/ React.createElement("li", {
            key: url,
            className: "store-social-media-stores-v2__list-item",
            "data-t": name
        }, /*#__PURE__*/ React.createElement("a", {
            href: url,
            target: "_blank",
            rel: "noreferrer",
            "aria-label": name
        }, /*#__PURE__*/ React.createElement("img", {
            className: "store-social-media-stores-v2__icon",
            src: iconUrl,
            alt: name
        })))
    )));
};

export { StoreSocialMedia as default };
//# sourceMappingURL=StoreSocialMedia.js.map
